module.exports = __webpack_public_path__ + "img/i-chat-gold.aa2cd7d2.svg";